import { useContext } from 'react';
import { userAuth } from '../contexts/userContext';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config';
import getClientSlug from '../helpers/clientSlug.js';

const CommonAPIService = () => {
	const { token, setToken } = useContext(userAuth);
	const navigate = useNavigate();

	async function sendRequest(quary) {
		const web_link = getConfig().REACT_APP_WEB_LINK;
		const slug = getClientSlug();
		const payload = slug ? { ...quary, slug: slug } : quary;

		return fetch(web_link, {
			method: 'post',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json',
				'sdk-authorization': `${token.session_key}`,
			},
			body: JSON.stringify(payload),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then((response) => {
				if (response.type === 'error' && response.message === 'Session expired') {
					setToken({});
					localStorage.removeItem('user-auth');
					navigate('/');
				}
				return response;
			});
	}

	return { sendRequest };
};

export default CommonAPIService;
